import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateTaskUserStatus extends Enum {
  key!: string;
  value!: string;
  color!: string;

  static TODO: EstateTaskUserStatus = {
    key: 'todo',
    get value() {
      return Lang.t('guidancestep.to-do');
    },
    color: 'rgb(196, 196, 196)'
  };

  static IN_PROGRESS: EstateTaskUserStatus = {
    key: 'in_progress',
    get value() {
      return Lang.t('estate.in-progress');
    },
    color: 'rgb(251, 197, 49)'
  };

  static COMPLETED: EstateTaskUserStatus = {
    key: 'completed',
    get value() {
      return Lang.t('estate.completed-status');
    },
    color: 'rgb(97, 208, 152)'
  };

  static CLOSED: EstateTaskUserStatus = {
    key: 'closed',
    get value() {
      return Lang.t('estate.closed');
    },
    color: 'rgb(249, 112, 104)'
  };

  static getActiveStatuses(): string[] {
    return [
      EstateTaskUserStatus.TODO.key,
      EstateTaskUserStatus.IN_PROGRESS.key,
      EstateTaskUserStatus.COMPLETED.key
    ];
  }

  static getDoneStatuses(): string[] {
    return [EstateTaskUserStatus.CLOSED.key];
  }

  static getValue(key: string): string | null {
    return EstateTaskUserStatus.getByKey(key)?.value ?? null;
  }

  static getColor(key: string): string {
    return EstateTaskUserStatus.getByKey(key)?.color ?? 'rgb(0, 0, 0)';
  }
}
